import {
    collection,
    doc,
    getDocs,
    orderBy,
    query,
    updateDoc,
    arrayUnion,
} from 'firebase/firestore';
import { db, auth } from '../firebase/firebase';
import { EmployeeInterest } from '../models/EmployeeInterest';

class EmployeeInterestService {
    constructor() {
        this.collection = 'employee_interests';
    }

    async fetchApplications() {
        const collectionRef = collection(db, this.collection);
        const q = query(collectionRef, orderBy('createdAt', 'desc'));
        const snapshot = await getDocs(q);
        return snapshot.docs.map((docSnap) => EmployeeInterest.fromFirebase(docSnap));
    }

    async updateStatus(applicationId, status, note = '') {
        const docRef = doc(db, this.collection, applicationId);
        const currentUser = auth.currentUser;
        const changedBy = currentUser?.displayName || currentUser?.email || 'unknown';

        const historyEntry = {
            status,
            note,
            changedBy,
            changedAt: new Date().toISOString(),
        };

        await updateDoc(docRef, {
            status,
            statusHistory: arrayUnion(historyEntry),
        });
    }
}

const employeeInterestService = new EmployeeInterestService();
export default employeeInterestService;
